import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import GoogleAnalytics from './components/GoogleAnalytics';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import QualificationPage from './pages/QualificationPage';
import InsuranceFormPage from './pages/InsuranceFormPage';
import CarInsuranceFormPage from './pages/CarInsuranceFormPage';
import CarInsuranceAdLandingPage from './pages/CarInsuranceAdLandingPage';
import HoustonCarInsuranceLandingPage from './pages/HoustonCarInsuranceLandingPage';
import HomeInsuranceAdLandingPage from './pages/HomeInsuranceAdLandingPage';
import HoustonHomeInsuranceLandingPage from './pages/HoustonHomeInsuranceLandingPage';
import GetQuotePage from './pages/GetQuotePage';
import GetQuoteThankYouPage from './pages/GetQuoteThankYouPage';
import PetInsuranceFormPage from './pages/PetInsuranceFormPage';
import HomeInsuranceFormPage from './pages/HomeInsuranceFormPage';
import InsuranceRequestsPage from './pages/InsuranceRequestsPage';
import SettingsProfilePage from './pages/SettingsProfilePage';
import SettingsBillingPage from './pages/SettingsBillingPage';
import SettingsSecurityPage from './pages/SettingsSecurityPage';
import NotificationsPage from './pages/NotificationsPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import VerifyEmailSuccessPage from './pages/VerifyEmailSuccessPage';
import YabarbequedPage from './pages/YabarbequedPage';
import AboutPage from './pages/AboutPage';
import HelpPage from './pages/HelpPage';
import BlogPage from './pages/BlogPage';
import KnowledgeBasePage from './pages/KnowledgeBasePage';
import Ho4RentersInsuranceArticlePage from './pages/Ho4RentersInsuranceArticlePage';
import RentersLiabilityArticlePage from './pages/RentersLiabilityArticlePage';
import HowToGetHo4ArticlePage from './pages/HowToGetHo4ArticlePage';
import Ho4VsHomeownersArticlePage from './pages/Ho4VsHomeownersArticlePage';
import Ho4CostTexasArticlePage from './pages/Ho4CostTexasArticlePage';
import Ho4DeductibleArticlePage from './pages/Ho4DeductibleArticlePage';
import Ho4LandlordRequiredArticlePage from './pages/Ho4LandlordRequiredArticlePage';
import Ho4TheftCoverageArticlePage from './pages/Ho4TheftCoverageArticlePage';
import Ho4WaterDamageArticlePage from './pages/Ho4WaterDamageArticlePage';
import Ho4WorthItArticlePage from './pages/Ho4WorthItArticlePage';
import Ho4RoommatesArticlePage from './pages/Ho4RoommatesArticlePage';
import Ho4SwitchCompaniesArticlePage from './pages/Ho4SwitchCompaniesArticlePage';
import Ho4ClaimsArticlePage from './pages/Ho4ClaimsArticlePage';
import Ho4CollegeStudentsTexasArticlePage from './pages/Ho4CollegeStudentsTexasArticlePage';
import Ho4PersonalPropertyCoverageArticlePage from './pages/Ho4PersonalPropertyCoverageArticlePage';
import Ho4StolenFromCarArticlePage from './pages/Ho4StolenFromCarArticlePage';
import Ho4AcvVsReplacementCostArticlePage from './pages/Ho4AcvVsReplacementCostArticlePage';
import Ho4LossOfUseArticlePage from './pages/Ho4LossOfUseArticlePage';
import Ho4ProofOfInsuranceArticlePage from './pages/Ho4ProofOfInsuranceArticlePage';
import Ho4LandlordPropertyDamageArticlePage from './pages/Ho4LandlordPropertyDamageArticlePage';
import Ho4MoldBedBugsArticlePage from './pages/Ho4MoldBedBugsArticlePage';
import Ho4NoInsuranceTexasArticlePage from './pages/Ho4NoInsuranceTexasArticlePage';
import Ho4FireSmokeArticlePage from './pages/Ho4FireSmokeArticlePage';
import Ho4PetLiabilityArticlePage from './pages/Ho4PetLiabilityArticlePage';
import Ho4FloodDamageArticlePage from './pages/Ho4FloodDamageArticlePage';
import PetKnowledgeArticleRoute from './pages/PetKnowledgeArticleRoute';
import AutoKnowledgeArticleRoute from './pages/AutoKnowledgeArticleRoute';
import ReferralPage from './pages/ReferralPage';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <GoogleAnalytics />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          
          {/* Insurance Flow */}
          <Route path="/qualify" element={<QualificationPage />} />
          <Route path="/insurance/new" element={<InsuranceFormPage />} />
          <Route path="/insurance/car" element={<CarInsuranceFormPage />} />
          <Route path="/car-insurance" element={<CarInsuranceAdLandingPage />} />
          <Route path="/car-insurance/houston" element={<HoustonCarInsuranceLandingPage />} />
          <Route
            path="/car-insurance/houston/:make/:model"
            element={<HoustonCarInsuranceLandingPage />}
          />
          <Route path="/home-insurance" element={<HomeInsuranceAdLandingPage />} />
          <Route path="/home-insurance/houston" element={<HoustonHomeInsuranceLandingPage />} />
          <Route path="/get-quote" element={<GetQuotePage />} />
          <Route path="/get-quote/thank-you" element={<GetQuoteThankYouPage />} />
          <Route path="/car-insurance-information" element={<Navigate to="/get-quote?type=car" replace />} />
          <Route path="/car-insurance-thank-you" element={<Navigate to="/get-quote/thank-you" replace />} />
          <Route path="/car-insurance-details" element={<CarInsuranceFormPage directLanding />} />
          <Route path="/car-insurance-texas-form" element={<Navigate to="/get-quote?type=car" replace />} />
          <Route path="/pet-insurance" element={<PetInsuranceFormPage directLanding />} />
          <Route path="/insurance/pet" element={<PetInsuranceFormPage />} />
          <Route path="/insurance/home" element={<HomeInsuranceFormPage />} />
          <Route path="/insurance/requests" element={<PrivateRoute><InsuranceRequestsPage /></PrivateRoute>} />
          
          {/* Settings Routes */}
          <Route path="/settings" element={<PrivateRoute><SettingsProfilePage /></PrivateRoute>} />
          <Route path="/settings/billing" element={<PrivateRoute><SettingsBillingPage /></PrivateRoute>} />
          <Route path="/settings/security" element={<PrivateRoute><SettingsSecurityPage /></PrivateRoute>} />

          {/* Notifications (Coming soon) */}
          <Route path="/notifications" element={<PrivateRoute><NotificationsPage /></PrivateRoute>} />

          {/* Legal */}
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />

          {/* Referral Program */}
          <Route path="/referral" element={<ReferralPage />} />

          {/* Retired B2B routes — redirect to consumer homepage */}
          <Route path="/for-property-managers" element={<Navigate to="/" replace />} />
          <Route path="/landlord/dashboard" element={<Navigate to="/" replace />} />
          <Route path="/rent/*" element={<Navigate to="/" replace />} />

          {/* Marketing / Support */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/knowledge-base" element={<KnowledgeBasePage />} />
          <Route path="/knowledge-base/what-is-ho4-renters-insurance" element={<Ho4RentersInsuranceArticlePage />} />
          <Route
            path="/knowledge-base/how-much-liability-do-i-need-for-renters-insurance"
            element={<RentersLiabilityArticlePage />}
          />
          <Route path="/knowledge-base/how-to-get-ho4-renters-insurance" element={<HowToGetHo4ArticlePage />} />
          <Route
            path="/knowledge-base/how-is-ho4-renters-insurance-different-from-homeowners-insurance"
            element={<Ho4VsHomeownersArticlePage />}
          />
          <Route path="/knowledge-base/how-much-does-ho4-cost-in-texas" element={<Ho4CostTexasArticlePage />} />
          <Route path="/knowledge-base/what-deductible-should-i-choose-for-ho4" element={<Ho4DeductibleArticlePage />} />
          <Route path="/knowledge-base/is-ho4-required-by-landlord" element={<Ho4LandlordRequiredArticlePage />} />
          <Route path="/knowledge-base/does-ho4-cover-theft" element={<Ho4TheftCoverageArticlePage />} />
          <Route path="/knowledge-base/does-ho4-cover-water-damage" element={<Ho4WaterDamageArticlePage />} />
          <Route path="/knowledge-base/is-ho4-worth-it" element={<Ho4WorthItArticlePage />} />
          <Route path="/knowledge-base/does-ho4-cover-roommates" element={<Ho4RoommatesArticlePage />} />
          <Route
            path="/knowledge-base/how-to-switch-ho4-insurance-companies"
            element={<Ho4SwitchCompaniesArticlePage />}
          />
          <Route
            path="/knowledge-base/how-to-file-a-renters-insurance-claim"
            element={<Ho4ClaimsArticlePage />}
          />
          <Route
            path="/knowledge-base/ho4-for-college-students-in-texas"
            element={<Ho4CollegeStudentsTexasArticlePage />}
          />
          <Route
            path="/knowledge-base/how-much-personal-property-coverage-do-i-need-for-renters-insurance"
            element={<Ho4PersonalPropertyCoverageArticlePage />}
          />
          <Route
            path="/knowledge-base/does-renters-insurance-cover-items-stolen-from-car"
            element={<Ho4StolenFromCarArticlePage />}
          />
          <Route
            path="/knowledge-base/actual-cash-value-vs-replacement-cost-renters-insurance"
            element={<Ho4AcvVsReplacementCostArticlePage />}
          />
          <Route
            path="/knowledge-base/what-is-loss-of-use-renters-insurance"
            element={<Ho4LossOfUseArticlePage />}
          />
          <Route
            path="/knowledge-base/how-to-get-proof-of-renters-insurance-for-landlord"
            element={<Ho4ProofOfInsuranceArticlePage />}
          />
          <Route
            path="/knowledge-base/does-renters-insurance-cover-damage-to-landlords-property"
            element={<Ho4LandlordPropertyDamageArticlePage />}
          />
          <Route
            path="/knowledge-base/does-renters-insurance-cover-mold-bed-bugs-pest-damage"
            element={<Ho4MoldBedBugsArticlePage />}
          />
          <Route
            path="/knowledge-base/what-happens-if-you-dont-have-renters-insurance-in-texas"
            element={<Ho4NoInsuranceTexasArticlePage />}
          />
          <Route
            path="/knowledge-base/does-renters-insurance-cover-fire-and-smoke-damage"
            element={<Ho4FireSmokeArticlePage />}
          />
          <Route
            path="/knowledge-base/does-renters-insurance-cover-dog-bites-and-pet-liability"
            element={<Ho4PetLiabilityArticlePage />}
          />
          <Route
            path="/knowledge-base/does-renters-insurance-cover-flood-damage"
            element={<Ho4FloodDamageArticlePage />}
          />
          <Route path="/knowledge-base/pet/:slug" element={<PetKnowledgeArticleRoute />} />
          <Route path="/knowledge-base/auto/:slug" element={<AutoKnowledgeArticleRoute />} />

          {/* Email verification helper (resend link, instructions) */}
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/verify-email/success" element={<VerifyEmailSuccessPage />} />

          {/* Secret Valentine page – only accessible via direct link */}
          <Route path="/yabarbequed" element={<YabarbequedPage />} />

        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
